import React, { useEffect } from 'react';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import {
  PageContainer,
  Container,
  Title,
  Message,
  BackLink,
} from './ThankYou.styled';

const ThankYou = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fadeIn = {
    hidden: { opacity: 0, y: 24 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] },
    },
  };

  const stagger = {
    visible: {
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.1,
      },
    },
  };

  return (
    <PageContainer>
      <Header />
      <Container initial="hidden" animate="visible" variants={stagger}>
        <Title variants={fadeIn}>Thank you</Title>
        <Message variants={fadeIn}>
          Your message has been sent successfully. We'll get back to you soon.
        </Message>
        <BackLink to="/contact">Back to Contact</BackLink>
      </Container>
      <Footer />
    </PageContainer>
  );
};

export default ThankYou;
